import styles from "./Hr.scss";

export default function Hr() {
  return <hr className={styles.hr} />;
}
